import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive, faPenToSquare, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import ModalEdit from './ModalEdit';
import { useSelector } from 'react-redux';

function List({ id_tab, id_parent, list }) {

    const stateParojectList = useSelector((state) => state.projectList);
    const stateSize = useSelector((state) => state.size);

    //Модальные окна
    const [modalEditShow, setModalEditShow] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    function modalEditHandler(model) {
        setSelectedId(model.ID);
        setModalEditShow(true);
    }

    return (
        <>
            {modalEditShow === true && (
                stateParojectList.list.filter(a => a.ID === selectedId).length > 0 &&
                <ModalEdit show={modalEditShow} onHide={() => setModalEditShow(false)} model={stateParojectList.list.filter(a => a.ID === selectedId)[0]} edit={true} />
            )}
            {
                list.filter(a => a.ID_Parent === id_parent).sort((a, b) => a.Name.localeCompare(b.Name)).map((model, index) => (
                    <div key={model.ID + '_' + model.ID_Status} >
                        <div className={model.Level === 0 ? 'list_item mt-30' : 'list_item mt-10'} style={{ marginLeft: stateSize.desktop !== true ? (10 * model.Level) + '%' : (5 * model.Level) + '%', backgroundColor: (model.ID_Status === 1 ? 'none' : '#d3d3d3') }} onClick={() => modalEditHandler(model)}>
                            <div style={{ width: (stateSize.desktop !== true ? '100%' : '70%') }}>
                                <div className='title'>{model.Name}</div>
                                <div className='subtitle'>
                                    {model.All_Object === true ? (
                                        <>
                                            <i>Задачи: <i className='text-success'>Да</i></i>
                                            <i className='ml-10'>Регулярные задачи: <i className='text-success'>Да</i></i>
                                            <i className='ml-10'>Доски: <i className='text-success'>Да</i></i>
                                        </>
                                    ) : (
                                        <>
                                            <i>Задачи: {stateParojectList.listObject.filter(a => a.ID_Project === model.ID & a.ID_Object === 1).length > 0 ? <i className='text-success'>Да</i> : <i className='text-danger'>Нет</i>}</i>
                                            <i className='ml-10'>Регулярные задачи: {stateParojectList.listObject.filter(a => a.ID_Project === model.ID & a.ID_Object === 2).length > 0 ? <i className='text-success'>Да</i> : <i className='text-danger'>Нет</i>}</i>
                                            <i className='ml-10'>Доски: {stateParojectList.listObject.filter(a => a.ID_Project === model.ID & a.ID_Object === 3).length > 0 ? <i className='text-success'>Да</i> : <i className='text-danger'>Нет</i>}</i>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="end">
                                {model.ID_Status === 0 && <FontAwesomeIcon icon={faArchive} className="opacity-50 fs-2" />}
                            </div>
                        </div>
                        <List id_tab={id_tab} id_parent={model.ID} list={list} />
                    </div>
                ))
            }
        </>
    )
}

export default List;
